import { destroySlicks, setSlick } from "../firebase/cooked-by";
import {
  append_to_dom,
  removeEmbeds,
  toggle_sidebar,
} from "../firebase/functions";

import { public_rate } from "../firebase/rating";

$(document).on("click", ".js-link", function (e) {
  e.preventDefault();
  const $this = $(this);
  const $target = $this.data("target");
  const $popups = $(".popup");

  $popups.removeClass("is-active");

  $($target).toggleClass("is-active");

  if ($this.hasClass("popup__close")) {
    $popups.removeClass("is-active");
  }
});

$(document).on("click", ".comment-toggle", function (e) {
  e.preventDefault();

  $(this).siblings(".recipe-comment").toggleClass("long-comment");

  $(this).html($(this).html() == "عرض المزيد" ? "عرض أقل" : "عرض المزيد");
});

//~++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ Toggle add to dom ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

$(document).on("click", "#popup-search-open", function () {
  append_to_dom("popup-search-open", "search-home", null);
});
$(document).on(
  "click",
  "#popup-login-open, #login-open-from-register",
  function () {
    append_to_dom("popup-login-open", "popup-login", null);
  }
);

$(document).on("click", "#popup-edit-password-open", function () {
  append_to_dom("popup-edit-password-open", "update_password", null);
});

$(document).on("click", "#popup-register-open", function () {
  append_to_dom("popup-register-open", "popup-register", null);
  $("#popup-login").remove();
});

$(document).on(
  "click",
  "#popup-forget-password-open,#reset-update-password-error>a",
  function () {
    append_to_dom("popup-forget-password-open", "forgot_password", null);
    $("#popup-login").remove();
  }
);

$(document).on("click", ".recipe-add", function () {
  if (localStorage.getItem("login_result")) {
    append_to_dom("popup-recipe-open", "popup-recipe", null);
  } else {
    localStorage.setItem("open_submit_recipe", true);
    append_to_dom("popup-login-open", "popup-login", null);
  }
});

//~++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ Toggle add to dom ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

//?++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ Toggle remove to dom ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
$(document).on("click", "#popup-recipe .popup-recipe-close", function () {
  $("#popup-recipe").remove();
  $("#recipe-submit-success").remove();
});

$(document).on("click", "#password-edit-success-close", function () {
  $("#password-edit-success").remove();
  $("#update_password").remove();
});

$(document).on("click", "#recipe-submit-success-close", function () {
  $("#popup-recipe").remove();
  $("#recipe-submit-success").remove();
});

$(document).on("click", "#popup-reset-password-close", function () {
  $("#forgot_password").remove();
  $("#reset-success").remove();
  localStorage.clear();
});

$(document).on("click", "#reset-success-close", function () {
  $("#reset-success").remove();
});

$(document).on("click", "#popup-register-close", function () {
  $("#popup-register").remove();
  localStorage.clear();
});

$(document).on("click", ".popup-authenticate-close", function () {
  $("#popup-authenticate").remove();
  $("#update_password").remove();
});

$(document).on(
  "click",
  "#update_password .remove-edit-password-card",
  function () {
    $("#update_password").remove();
  }
);

$(document).on("click", "#popup-login-close", function () {
  if (
    localStorage.getItem("pending_rating") &&
    localStorage.getItem("pending_rating_result")
  ) {
    let rating = JSON.parse(localStorage.getItem("pending_rating_result"));
    public_rate(rating.rate, rating.post_id);
    localStorage.removeItem("pending_rating_result");
    localStorage.removeItem("pending_rating");
  }
  $("#popup-login").remove();
  localStorage.clear();
});

$(document).on("click", ".update_reset_password_close", function () {
  $("#update_reset_password").remove();
});

$(document).on("click", "#popup-cock .popup-cock-close", function () {
  $("#popup-cock").remove();
  if (localStorage.getItem("cookby_should_open")) {
    localStorage.removeItem("cookby_should_open");
  }
});

$(document).on("click", "#popup-book .popup-book-close", function () {
  $("#add_to_new_cookbook_box").removeClass("is-form-open");
  $("#add_to_cookbook_submit_container").css("display", "none");
  if (localStorage.getItem("render_cookbooks")) {
    localStorage.removeItem("render_cookbooks");
  }
  $("#popup-book").remove();
});

$(document).on("click", "#reset-password-success-close", function () {
  $("#reset-password-success").remove();
});

$(document).on("click", "#subscription-success-close", function () {
  $("#subscription-success").remove();
});

$(document).on("click", "#register-success-close", function () {
  $("#register-success").remove();
});

$(document).on("click", "#popup-recipe-open-mobile", function () {
  toggle_sidebar(false);
});

//?++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ Toggle remove to dom ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ Toggle Popup Menu ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

$("#popup-menu-toggle").on("click", function () {
  if ($("#popup-menu").hasClass("is-active")) {
    toggle_sidebar(false);
  } else {
    append_to_dom("poup-menu-open", "popup-menu", toggle_sidebar(true));
  }
});

//*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ Toggle Popup Menu ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

$(".wrapper").on("click", function (e) {
  const $popup = $(".popup--search");
  const $popupInner = $(".popup__inner");
  const $search = $(".js-field");
  const $link = $(".js-link > img");
  const $story = $(".popup--story");
  const $favorite = $(".popup--favorite");
  const $storyPhoto = $(".popup--photo");

  if ($popup.hasClass("is-active")) {
    if (e.target == $popup[0]) {
      $popup.remove();
    }
  }

  if (
    $story.hasClass("is-active") ||
    $favorite.hasClass("is-active") ||
    $storyPhoto.hasClass("is-active")
  ) {
    if (
      e.target == $story[0] ||
      e.target == $favorite[0] ||
      e.target == $storyPhoto[0]
    ) {
      $story.removeClass("is-active");
      $favorite.removeClass("is-active");
      $storyPhoto.removeClass("is-active");
    }
  }

  // TODO add another selectors
  // $("#popup-cooked-list .popup__close img")
  // $("#popup-favorite-list .popup__close img")

  if (
    $(e.target).is($("#popup-cooked-list")) ||
    $(e.target).is($("#popup-favorite-list"))
  ) {
    if ($("#popup-favorite-list").length) {
      $("#popup-favorite-list").remove();
    }
    if ($("#popup-cooked-list").length) {
      $("#popup-cooked-list").remove();
    }
    destroySlicks();
  }
});

$(document).on(
  "click",
  ".popup--story .swiper-nav li:not('.is-active')",
  () => {
    removeEmbeds();
  }
);
$(document).on(
  "click",
  ".popup--favorite .popup__nav li:not('.is-active')",
  () => {
    setSlick();
  }
);

$(".js-favorite").on("click", function (e) {
  e.preventDefault();
  const $this = $(this);
  const $target = $this.data("target");
  const $tooltips = $(".tooltip");

  $tooltips.removeClass("is-active");

  $($target).toggleClass("is-active");

  setTimeout(function () {
    $($target).removeClass("is-active");
  }, 2000);
});

$(".js-field").on("focus", function (e) {
  e.preventDefault();

  $(".popup--search").addClass("search-is-active");
});

$(".js-search .search__field").on("focus", function (e) {
  e.preventDefault();

  if ($(window).width() < 812) {
    $(".popup--search").toggleClass("is-active");
  }
});

$(".scroll-btn").on("click", function (e) {
  e.preventDefault();

  $("html, body").animate(
    {
      scrollTop: 0,
    },
    300
  );
});

var more_clicked = false;
$(".js-more-btn").on("click", function (e) {
  e.preventDefault();
  if (more_clicked) {
    $(".js-more-btn").text("عرض المزيد");
    more_clicked = false;
  } else {
    $(".js-more-btn").text("عرض أقلّ");
    more_clicked = true;
  }
  $(".js-more").slideToggle();
});

$(".js-box").on("click", function (e) {
  e.preventDefault();
  $(this).addClass("form-is-visible");
});

$(".js-tabs .tabs__nav a").on("click", function (e) {
  e.preventDefault();
  const $this = $(this);
  const $href = $this.attr("href");

  $this.parent().addClass("is-active").siblings().removeClass("is-active");

  const $tabs = $(".tab");

  $tabs.removeClass("is-current");

  $($href).addClass("is-current");
});

$(".btn-play").on("click", function (e) {
  e.preventDefault();
  const $this = $(this);
  $this.addClass("is-not-visible");
  $this.closest(".article").addClass("play-video");
  $this.closest(".galery").addClass("play-video");
  $this.closest(".story").addClass("play-video");

  $(".js-iframe").attr("src", $(".js-iframe").attr("src") + "?autoplay=1");
});

$(document).on("click", ".js-dropdown-link", function (e) {
  let preventEvent = true;
  if (e.target.className.includes("can-expand")) {
    preventEvent = false;
  }

  if (preventEvent) {
    e.preventDefault();

    const $this = $(this);
    $this.toggleClass("is-active");
    $this.next().slideToggle();
    return false;
  }
});

$(".show_cookbook").on("click", function () {
  window.scrollTo({ top: 0 });
});
